import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TRANSITION } from 'shared/components/motion/tokens';
import { Header } from 'shared/components/layout/Header';
import { PresentationModeBar } from 'shared/components/layout/PresentationModeBar';
import { PlayerBottomNav } from 'shared/components/layout/PlayerBottomNav';
import { DemoGuide } from 'shared/components/layout/DemoGuide';
import { useAuth } from 'shared/hooks/useAuth';
import { usePageTitle } from 'shared/hooks/usePageTitle';
import { cn } from 'shared/utils/cn';
import { ROUTES } from 'shared/constants/routes';

export function MainLayout() {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();
  usePageTitle();
  const section = pathname.split('/')[1] || 'home';
  // Entrar/Cadastro são telas próprias, em tela cheia: sem cabeçalho, barra de personas ou
  // navegação inferior do app (o acesso rápido às personas fica dentro do próprio login).
  const isAuthPage = pathname === ROUTES.LOGIN || pathname === ROUTES.SIGNUP;
  // O onboarding da arena também é uma tela "de foco": tem a própria barra, sem a do app.
  const isFocusPage = isAuthPage || pathname === ROUTES.ARENA_ONBOARDING;
  const showPlayerNav = isAuthenticated && user?.role === 'jogador' && !isAuthPage;

  return (
    <div className="flex min-h-screen flex-col">
      {!isFocusPage && <Header />}
      {!isFocusPage && <PresentationModeBar />}
      <main className={cn('flex-1', showPlayerNav && 'pb-16')}>
        {/* Chave pela seção (/arena, /agenda…), não pela URL inteira: dentro de uma seção com
            layout próprio (ex.: painel da arena) a moldura fica parada e só o conteúdo anima. */}
        <motion.div key={section} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={TRANSITION}>
          <Outlet />
        </motion.div>
      </main>
      {showPlayerNav && <PlayerBottomNav />}
      <DemoGuide />
    </div>
  );
}
